const WA_NUMBER = "6285196091527";

export const waUrl = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

export const WHATSAPP_URL = waUrl(
  "Halo Ihtifaal! Saya ingin merayakan momen saya secara digital."
);

export const SERVICES = [
  {
    id: "wedding",
    name: "Undangan Pernikahan",
    tagline: "Hari bahagia, dibuka dari satu tautan.",
    desc: "Undangan digital elegan yang bisa dibagikan lewat satu tautan — lengkap dengan RSVP, peta lokasi, galeri, dan hitung mundur hari bahagia.",
    cta: "Rancang Undanganku",
    waText: "Halo Ihtifaal! Saya ingin merancang undangan pernikahan digital.",
    url: "ihtifaal.com/wedding/andi-sarah",
    price: "Mulai Rp 49 rb",
    catalogUrl: "https://ihtifaal.com/wedding",
    examples: [
      { label: "Undangan Basic — Andry & Dhea", url: "https://ihtifaal.com/wedding/Andry-Dhea/" },
      { label: "Tema Bola (Madrid) v1", url: "https://ihtifaal.com/un/madrid1/" },
      { label: "Tema Bola (Madrid) v2", url: "https://ihtifaal.com/un/madrid2/" },
      { label: "Tema Game Interaktif (Naruto)", url: "https://katalog.ihtifaal.com/naruto/?to=bapak+jokowi" },
      { label: "Undangan 3D", url: null },
    ],
    accent: "#E8B4A8",
    accentDeep: "#8E4A54",
    glow: "rgba(232,180,168,0.32)",
    frame: "card",
    showcaseCaption: "Andi & Sarah — 12.12.2026",
    image:
      "https://images.unsplash.com/photo-1633037773384-27d7ac0491e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwaW52aXRhdGlvbiUyMGRpZ2l0YWwlMjBkZXNpZ258ZW58MHx8fHwxNzg4MTU3Nzc5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "umkm",
    name: "Website UMKM",
    tagline: "Usahamu, naik kelas ke etalase digital.",
    desc: "Etalase digital untuk usahamu: katalog produk, tombol pesan langsung ke WhatsApp, dan alamat web yang mudah diingat pelanggan.",
    cta: "Digitalisasi Usahaku",
    waText: "Halo Ihtifaal! Saya ingin membuat website untuk usaha/UMKM saya.",
    url: "kopi-senja.ihtifaal.com",
    price: "Mulai Rp 150 rb",
    catalogUrl: "https://umkm.ihtifaal.com/",
    examples: [
      { label: "Angkringan Sarangloe", url: "https://sarangloe.ihtifaal.com/" },
      { label: "Geprek Angkasa", url: null },
    ],
    accent: "#2AA79B",
    accentDeep: "#005C53",
    glow: "rgba(42,167,155,0.28)",
    frame: "phone",
    showcaseCaption: "Kopi Senja — Seduh. Pesan. Datang.",
    image:
      "https://images.unsplash.com/photo-1594402919317-9e67dca0a305?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMGJ1c2luZXNzJTIwY2FmZSUyMHdlYnNpdGV8ZW58MHx8fHwxNzg4MTU3Nzc5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "influencer",
    name: "Web Profil Personal",
    tagline: "Personal brand-mu, punya rumah sendiri.",
    desc: "Rumah digital untuk influencer, pendakwah, hingga pejabat: portofolio, media kit, rate card, dan link-in-bio yang naik kelas — bukan sekadar daftar tautan.",
    cta: "Rapikan Profilku",
    waText: "Halo Ihtifaal! Saya ingin membuat website profil personal.",
    url: "profil.ihtifaal.com",
    price: "Mulai Rp 100 rb",
    catalogUrl: "https://profil.ihtifaal.com/",
    examples: [
      { label: "Profil Pendakwah — Ihtisamul Hasan", url: "https://ihtisamulhasan.ihtifaal.com/" },
      { label: "Profil Pejabat — Mulyono Cianjay", url: "https://mulyono-cianjay.ihtifaal.com/" },
      { label: "Profil Influencer", url: null },
    ],
    accent: "#B06BFF",
    accentDeep: "#5B21B6",
    glow: "rgba(138,43,226,0.32)",
    frame: "phone",
    showcaseCaption: "Rana — @rana.daily",
    image:
      "https://images.unsplash.com/photo-1646554399276-52261643a93d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxpbmZsdWVuY2VyJTIwcHJvZmlsZSUyMGZhc2hpb258ZW58MHx8fHwxNzg4MTU3Nzc5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "masjid",
    name: "Portal Masjid",
    tagline: "Syiar digital untuk rumah Allah. Gratis.",
    desc: "Portal gratis untuk masjid: jadwal shalat, pengumuman, laporan kas, dan galeri kegiatan. Untuk syiar, selamanya gratis.",
    cta: "Daftarkan Masjid",
    waText: "Halo Ihtifaal! Saya ingin mendaftarkan portal web gratis untuk masjid kami.",
    url: "masjid-alfalah.ihtifaal.com",
    price: "Gratis (S&K berlaku)",
    catalogUrl: "https://masjid.ihtifaal.com/",
    examples: [
      { label: "Masjid Al-Falah Pasadena", url: null },
      { label: "Ponpes Nurul Istadz Bantul", url: null },
    ],
    accent: "#50C878",
    accentDeep: "#0B6E4F",
    glow: "rgba(80,200,120,0.26)",
    frame: "phone",
    badge: "GRATIS SELAMANYA",
    showcaseCaption: "Masjid Al-Falah — Jadwal & Kegiatan",
    image:
      "https://images.unsplash.com/photo-1537181534458-45dcee76ae90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtb3NxdWUlMjBhcmNoaXRlY3R1cmUlMjBiZWF1dGlmdWx8ZW58MHx8fHwxNzg4MTU3Nzc5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "gift",
    name: "Web Kejutan Hadiah",
    tagline: "Kado yang dibuka lewat layar.",
    desc: "Web kejutan untuk anniversary, ulang tahun pasangan, atau permintaan maaf — dibuka seperti kado, diakhiri dengan senyuman.",
    cta: "Siapkan Kejutan",
    waText: "Halo Ihtifaal! Saya ingin membuat web kejutan hadiah untuk pasangan saya.",
    url: "gift.ihtifaal.com/budi-ke-ani",
    price: "Mulai Rp 5 rb",
    catalogUrl: "https://homegift.ihtifaal.com",
    examples: [
      { label: "Anniversary — Rahma & Fandi", url: "https://gift.ihtifaal.com/temp2/rahma-fandi/" },
      { label: "Ulang Tahun — Ahsan & Lily", url: "https://gift.ihtifaal.com/BDay/1/ahsan-lily/" },
      { label: "Web Ta'aruf", url: null },
    ],
    accent: "#FF9A76",
    accentDeep: "#C24E22",
    glow: "rgba(255,127,80,0.30)",
    frame: "card",
    showcaseCaption: "Untuk Ani, dari Budi",
    image:
      "https://images.unsplash.com/photo-1671150590216-f138600130ce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxnaWZ0JTIwYm94JTIwc3VycHJpc2UlMjBvcGVufGVufDB8fHwxNzg4MTU3Nzc5fDA&ixlib=rb-4.1.0&q=85",
  },
];

// Kompresi gambar: minta versi kecil & terkompres dari Unsplash
SERVICES.forEach((s) => {
  s.image = s.image.replace("q=85", "q=60&w=640&auto=format&fit=crop");
});
